exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.body-setting-template[data-v-1cf4665b] {\n  border-radius: 5px;\n  margin: 10px;\n}\n.body-setting-template .setting-card-content[data-v-1cf4665b] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n}\n.body-setting-template .parts-name[data-v-1cf4665b] {\n    padding: 6px;\n    font-size: 12px;\n    font-weight: 600;\n}\n.body-setting-template .card-content[data-v-1cf4665b] {\n    padding: 16px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1cf4665b","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/DashBoard/ChatBot/ScenarioParts.vue
// module id = 0jo3
// module chunks = 3